// src/components/SendRequestModal.js

import React from 'react';
import { Box, Typography, TextField, Button, Modal } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

const StyledModal = styled(Modal)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    borderRadius: '16px',
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    padding: theme.spacing(1.5, 3),
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
        boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.15)',
    },
}));

const ModalBox = styled(Box)(({ theme }) => ({
    backgroundColor: '#ffffff',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    width: '90%',
    maxWidth: 500,
    maxHeight: '90vh',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
    },
}));

const SendRequestModal = ({
    open,
    handleClose,
    ownerFirstName,
    message,
    setMessage,
    handleSendRequest
}) => {
    return (
        <StyledModal
            open={open}
            onClose={handleClose}
            aria-labelledby="send-request-modal-title"
            aria-describedby="send-request-modal-description"
        >
            <ModalBox>
                <Typography id="send-request-modal-title" variant="h6" component="h2" gutterBottom>
                    Send Request to {ownerFirstName}
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    placeholder="Introduce yourself and ask any questions you may have..."
                />
                <StyledButton
                    onClick={handleSendRequest}
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    sx={{ mt: 2 }}
                >
                    Send Request
                </StyledButton>
            </ModalBox>
        </StyledModal>
    );
};

SendRequestModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    ownerFirstName: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    setMessage: PropTypes.func.isRequired,
    handleSendRequest: PropTypes.func.isRequired,
};

export default SendRequestModal;
